import { useCallback } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import {
  useCreate,
  useNotify,
  SimpleForm,
  TextInput,
  Create,
  NumberInput,
  useResourceContext,
  required,
  number,
  maxLength,
  useRefresh,
  useTranslate,
} from "react-admin";
import SaveDeleteBtns from "../../saveDeleteBtns/SaveDeleteBtn";
import Transition from "../../transition/Transition";
import TransportItemForm from "../components/TransportItemForm";
import sanitizeData from "../../../utils/sanitizeData";
import errorSubmitHandler from "../../../utils/errorSubmitHandler";

const validateCode = [required(), maxLength(20)];
const validateName = [required(), maxLength(125)];
const validateBrand = [maxLength(50)];
const validateCapacity = [number()];
const validatePlate = [maxLength(20)];

export default function TransportAddDialog({ open, setOpen }) {
  const [create] = useCreate();
  const notify = useNotify();
  const refresh = useRefresh();
  const resource = useResourceContext(); // cuman nama resource
  const t = useTranslate();

  const save = useCallback(
    async (values) => {
      try {
        await create(
          resource,
          { data: sanitizeData(values) },
          {
            returnPromise: true,
            onSuccess: (data) => {
              notify("ra.notification.created", {
                messageArgs: { smart_count: 1 },
              });
              setOpen(false);
              refresh();
            },
          }
        );
      } catch (error) {
        return errorSubmitHandler(error, notify);
      }
    },
    [create]
  );

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted={false}
      TransitionComponent={Transition}
    >
      <Create title={" "} sx={{ "& .RaCreate-main": { mt: 0 } }}>
        <SimpleForm
          warnWhenUnsavedChanges
          onSubmit={save}
          toolbar={<SaveDeleteBtns />}
          mode="onBlur"
          reValidateMode="onBlur"
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pt: 0,
            }}
          >
            <DialogTitle>{t("mine.dialog.create_transport")}</DialogTitle>
            <IconButton onClick={handleClose} sx={{ mr: "11px" }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <DialogContent>
            <TextInput
              variant="outlined"
              source="code"
              label="mine.label.code"
              fullWidth
              isRequired
              validate={validateCode}
            />

            <TextInput
              variant="outlined"
              source="name"
              label="mine.label.name"
              fullWidth
              isRequired
              validate={validateName}
            />
            <TextInput
              variant="outlined"
              source="brand"
              label="mine.label.brand"
              fullWidth
              validate={validateBrand}
            />
            <TextInput
              variant="outlined"
              source="type"
              label="mine.label.type"
              fullWidth
              validate={validateBrand}
            />
            <TextInput
              variant="outlined"
              source="kind"
              label="mine.label.kind"
              fullWidth
              validate={validateBrand}
            />
            <NumberInput
              variant="outlined"
              source="capacity"
              label="mine.label.capacity"
              fullWidth
              validate={validateCapacity}
            />
            <TextInput
              variant="outlined"
              source="plate"
              label="mine.label.plate"
              fullWidth
              validate={validatePlate}
            />

            <TransportItemForm />
          </DialogContent>
        </SimpleForm>
      </Create>
    </Dialog>
  );
}
